export function normalizeResponse<TInput, TOutput = TInput>(
  responsePromise: Promise<Response>,
  normalizeFn: (input: TInput) => TOutput
): Promise<TOutput> {
  return responsePromise
    .then((response) => response.json())
    .then((json) => normalizeFn(json))
    .catch((error) => normalizeFn(error as TInput));
}
